<script lang="ts" setup>
import { BButton } from 'bootstrap-vue-next';
</script>

<template>
  <div id="public-document-column">
    <RouterLink to="/">
      <img
        src="@/assets/images/logo-light.svg"
        class="logo"
        alt="Sampling Human"
      />
    </RouterLink>
    <div id="public-document-content">
      <slot />
    </div>
    <b-button variant="outline-light" size="sm" @click="$router.push('/')">
      <font-awesome-icon icon="angle-left" class="me-2" /> Back to Home
    </b-button>
  </div>
</template>

<style>
#public-document-column {
  width: 90vw;
  max-width: 1200px;
  margin: 2rem auto;
  text-align: left;
}
#public-document-column img.logo {
  width: 150px;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
#public-document-content {
  width: 100%;
  padding: 2rem;
  margin: 1rem 0;
  background-color: white;
  color: #444;
  text-align: justify;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
/* RESPONSIVE */
@media screen and (max-width: 500px) {
}
</style>
